import { useEffect, useState } from "react";
import { getCustomerList } from "../services/customers";

export const useCustomerOptions = () => {
  const [customerOptions, setCustomerOptions] = useState([]);
  const [loadingCustomer, setLoadingCustomer] = useState(false);

  const getCustomerOptions = async (queryString) => {
    try {
      setLoadingCustomer(true);
      const store = localStorage.getItem("customers");
      const results = store
        ? JSON.parse(store)?.results
        : await getCustomerList(queryString);

      console.log("results", results)

      setCustomerOptions(
        results.map((item) => ({
          value: item.id,
          label: item.name[0] + " " + item.name[1],
          ...item,
        }))
      );
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingCustomer(false);
    }
  };

  useEffect(() => {
    getCustomerOptions();
  }, []);

  return { customerOptions, loadingCustomer, getCustomerOptions };
};